import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { WarehouseData } from 'types/api/customer.type';

import type { RootState } from '../store';

const warehouseAdapter = createEntityAdapter({
  selectId: (warehouse: WarehouseData) => warehouse.id,
});

export const warehousesSlice = createSlice({
  name: 'warehouses',
  initialState: warehouseAdapter.getInitialState(),
  reducers: {
    setAllWarehouses(state, action) {
      warehouseAdapter.setAll(state, action.payload);
    },
    setWarehouse(state, action) {
      warehouseAdapter.setOne(state, action.payload);
    },
    removeWarehouse(state, action) {
      warehouseAdapter.removeOne(state, action.payload);
    },
  },
});

export const getState = (rootState: RootState) => rootState.warehouses;

export const warehouseSelector = warehouseAdapter.getSelectors(
  (state: RootState) => state.warehouses
);

export const { setAllWarehouses, setWarehouse, removeWarehouse } = warehousesSlice.actions;
